import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

export interface Sort {
  key: string;
  reverse: boolean;
}

@Component({
  selector: 'to-sort-link',
  templateUrl: './sort-link.html',
  styleUrls: ['./sort-link.css'],
})
export class SortLinkComponent {
  @Input() sort: Sort;
  @Input() key: string;
  @Input() name: string;
  @Input() largeName: string;
  @Input() smallName: string;

  sortchange() {
    if (this.sort.key !== this.key) {
      this.sort.reverse = false;
    } else {
      this.sort.reverse = !this.sort.reverse;
    }
    this.sort.key = this.key;
  }
}

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [SortLinkComponent],
  exports: [SortLinkComponent]
})
export class SortLinkModule { }
